export default __webpack_public_path__ + "static/media/TourPage_01.e20283fc.jpg";